module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-spinner"
  }, [_c('div', {
    staticClass: "loading-spinner-inner"
  }, [_c('label', [_vm._v("\t●")]), _vm._v(" "), _c('label', [_vm._v("\t●")]), _vm._v(" "), _c('label', [_vm._v("\t●")]), _vm._v(" "), _c('label', [_vm._v("\t●")]), _vm._v(" "), _c('label', [_vm._v("\t●")]), _vm._v(" "), _c('label', [_vm._v("\t●")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-d118721c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loading.vue
// module id = 131
// module chunks = 1